import React from "react";
import { Component } from "react";
import { ScrollView, Animated, Keyboard } from "react-native";
import chatstyles from "../styles/chatStyles";
import ChatBox from "./ChatBox";
import AgentTransferring from "./AgentTransferring";
import Widget from "./Widget";
import PolicyQuoteWidget from "./PolicyQuoteWidget";
import SystemMessages from "./SystemMessages";
class ChatContainer extends Component {
  constructor(props) {
    super(props);
    this.scrollView = React.createRef();
    this.keyboardHeight = new Animated.Value(0);
    this.state = {
      chatScreenFlag: false,
      scrolltobottom: false,
    };
  }
  UNSAFE_componentWillMount() {
    Keyboard.dismiss();
    this.keyboardDidShowListener = Keyboard.addListener(
      "keyboardDidShow",
      this._keyboardDidShow.bind(this)
    );
    this.keyboardDidHideListener = Keyboard.addListener(
      "keyboardDidHide",
      this._keyboardDidHide.bind(this)
    );
    if (global.platform === "ios") {
      this.keyboardWillShowSub = Keyboard.addListener(
        "keyboardWillShow",
        this.keyboardWillShow
      );
      this.keyboardWillHideSub = Keyboard.addListener(
        "keyboardWillHide",
        this.keyboardWillHide
      );
    }
  }

  keyboardWillShow = (event) => {
    Animated.parallel([
      Animated.timing(this.keyboardHeight, {
        duration: event.duration,
        toValue: event.endCoordinates.height,
      }),
    ]).start();
  };

  keyboardWillHide = (event) => {
    Animated.parallel([
      Animated.timing(this.keyboardHeight, {
        duration: event.duration,
        toValue: 0,
      }),
    ]).start();
  };
  //Called immediately before a component is destroyed
  componentWillUnmount() {
    this.keyboardDidShowListener.remove();
    this.keyboardDidHideListener.remove();
    if (global.platform === "ios") {
      this.keyboardWillShowSub.remove();
      this.keyboardWillHideSub.remove();
    }
  }
  _keyboardDidShow() {
    //alert(this.scrollView);
    this.scrollView.scrollToEnd({ animated: true });
    this.setState({
      scrolltobottom: true,
    });
  }
  _keyboardDidHide() {
    //alert("Keyboard Hidden");
    this.setState({
      scrolltobottom: false,
    });
  }
  //on screen load method
  componentDidMount() {}

  //render ui
  render() {
    return (
      <ScrollView
        ref={(ref) => (this.scrollView = ref)}
        contentContainerStyle={[
          this.state.scrolltobottom
            ? chatstyles.contentContainer
            : chatstyles.contentonkeyboard,
        ]}
        onContentSizeChange={() => {
          if (this.scrollView) {
            this.scrollView.scrollToEnd({ animated: true });
          }
        }}
      >
        {this.props.messages &&
          this.props.messages.length > 0 &&
          this.props.messages.map((each, index) => {
            let tempArray = this.props.messages.slice(index + 1);
            let tempObj = tempArray.find((findEach) => {
              return (
                (findEach.buttons && findEach.buttons.length) ||
                findEach.disableOptions ||
                (findEach.widget && findEach.widget.length) ||
                (findEach.checkbox && findEach.checkbox.length) ||
                (findEach.link &&
                  findEach.link.type &&
                  findEach.link.type !== "annual_payment" &&
                  findEach.link.type !== "monthly_payment") ||
                findEach.type === "agent_handoff"
              );
            });

            switch (each.type) {
              case "text":
                //hide buttons if already answered
                if (this.props.loginType === "bot" || tempObj) {
                  delete each.buttons;
                  delete each.widgetButtons;
                  delete each.checkbox;
                  delete each.link;
                  if (each.widget) {
                    each.widget = each.widget.map((eachWidget) => ({
                      ...eachWidget,
                      editable: false,
                    }));
                  }
                }

                //buttons for widgets
                if (
                  each.buttons &&
                  each.buttons.length &&
                  each.widget &&
                  each.widget.length
                ) {
                  each.widgetButtons = each.buttons;
                  delete each.buttons;
                }
                return (
                  <React.Fragment key={`chatKey${index}`}>
                    {each.policyQuoteWidget != "" && each.policyQuoteWidget && (
                      <PolicyQuoteWidget
                        policyQuoteWidget={each.policyQuoteWidget}
                        botMessage={each}
                      />
                    )}
                    <ChatBox
                      key={`chatBoxKey${index}`}
                      idValue={index}
                      botMessage={each}
                      isAgentConnected={this.props.isAgentConnected}
                      loginType={this.props.loginType}
                      updateSentMessage={this.props.updateSentMessage}
                      customerId={this.props.customerId}
                      showTerms={this.props.showTerms}
                      disableOptions={this.props.disableOptions}
                      disableOptions={this.props.disableOptions}
                      initiateChat={this.props.initiateChat}
                    />

                    {each.widget && each.widget.length > 0 && (
                      <Widget
                        widget={each.widget}
                        botMessage={each}
                        buttons={each.widgetButtons}
                        updateSentMessage={this.props.updateSentMessage}
                        keepButtons={this.props.loginType !== "bot" && !tempObj}
                        disableOptions={this.props.disableOptions}
                      />
                    )}
                  </React.Fragment>
                );
              case "rating":
                return (
                  <ChatBox
                    key={`chatRatingKey${index}`}
                    idValue={index}
                    botMessage={each}
                    isAgentConnected={this.props.isAgentConnected}
                    loginType={this.props.loginType}
                    updateSentMessage={this.props.updateSentMessage}
                    disableOptions={this.props.disableOptions}
                    ratingsFlag={
                      this.props.loginType === "bot" || tempObj ? false : true
                    }
                  />
                );
              case "agent_handoff":
                return (
                  <React.Fragment key={`chatAgentKey${index}`}>
                    <ChatBox
                      botMessage={each}
                      idValue={index}
                      isAgentConnected={this.props.isAgentConnected}
                      loginType={this.props.loginType}
                      updateSentMessage={this.props.updateSentMessage}
                    />
                    {this.props.loginType === "customer" &&
                      index === this.props.messages.length - 1 && (
                        <AgentTransferring
                          loginType={this.props.loginType}
                          url={each}
                        />
                      )}
                  </React.Fragment>
                );
              case "agent_connected":
                return (
                  this.props.loginType === "customer" && (
                    <SystemMessages message={each.message} />
                  )
                );
            }
          })}

        {this.props.isAgentTyping && (
          <ChatBox
            botMessage={{
              interactionType: "live_agent",
            }}
            isAgentConnected={this.props.isAgentConnected}
            isAgentTyping={this.props.isAgentTyping}
            loginType={this.props.loginType}
          />
        )}
      </ScrollView>
    );
  }
}

export default ChatContainer;
